import Button from "@app/sharedComponents/Button/Button"
import { Theme, ThemedText, ThemedView } from "@app/theme"
import Right from '../../../assets/Icons/Right'
import Stepper from '../../../assets/Icons/StepperInProgress'
import { formatIndianCurrency } from "@app/utils/utility"
import dayjs from "dayjs"
import { useEffect, useState } from "react"
import axios from "axios"
import { endpoints } from "@app/api/apis"
import { useAppSelector } from "@app/store/hooks"
import ROUTE from "@app/navigationApp/routes"
import PageHeaders from "@app/sharedComponents/CommonHeader/CommonHeader"
import fetchUserDetails from "@app/helper/fetchUserInfo"
import { useTheme } from "@shopify/restyle"
const advancedFormat = require('dayjs/plugin/advancedFormat');
dayjs.extend(advancedFormat);

const RenewalStatus =({navigation,route})=>{
    const showPageHeader = route?.params?.showPageHeader ?? true
    const [renewalStatus,setRenewalStatus] = useState({});
    const userDetails = useAppSelector((state) => state.auth.userDetails);
    const {colors} = useTheme<Theme>()

    const fetchPendingRequests = () => {
        const url = endpoints.pendingRequests + userDetails?.linkedCredits[0]?.creditId      
        axios.get(url).then((res)=>{
            setRenewalStatus(res?.data?.renewalRequestDetailsList[0]??{})
        }).catch((err)=>{
            console.log('fetchPendingRequests',err)
        })
    }

    useEffect(()=>{
        if(!showPageHeader){
            fetchUserDetails()
        }
        fetchPendingRequests()
    },[])

    const {updatedCreditLimit,createdOn,expectedRenewalCompletionDate} = renewalStatus
    return(
        <>
        {showPageHeader && <PageHeaders pageName={route?.name} navigation={navigation} />}
        <ThemedView flex={1} backgroundColor="bg-surface-primary" p="lg" >
            
            <ThemedView mt="sm" p="lg" backgroundColor="bg-fill-primary" borderColor="border-primary" borderWidth={1} borderTopLeftRadius="sm" borderTopRightRadius="sm">
               <ThemedText variant="b3r" color="text-secondary" mb="xs">Loan renewal request recieved</ThemedText>
               <ThemedView flexDirection="row" alignItems="center" >
                   <ThemedText variant="l1" color="text-emphasis-secondary">₹</ThemedText>
                   <ThemedText variant="h1b" color="text-emphasis-secondary">{formatIndianCurrency(updatedCreditLimit)}</ThemedText>
               </ThemedView>
            </ThemedView>
            <ThemedView p="lg" backgroundColor="bg-fill-primary" borderColor="border-primary" borderWidth={1} borderTopWidth={0} borderBottomLeftRadius="sm" borderBottomRightRadius="sm">
            <ThemedView  mb="lg" position="relative">
                    <ThemedView flexDirection='row' mb="4xl"> 
                    <ThemedView backgroundColor="bg-fill-emphasis-primary-1" width={32} height={32} borderRadius="full" justifyContent="center" alignItems="center">
                        <ThemedView backgroundColor="bg-surface-primary" width={24} height={24} borderRadius="full" justifyContent="center" alignItems="center">
                        <Right size={16} color={colors['icon-action-primary']}/>
                        </ThemedView>
                    </ThemedView>
                        <ThemedView ml='sm'>
                            <ThemedText variant='b3s' color='text-disabled'>Request placed successfully</ThemedText>
                            <ThemedText variant='b4r' color='text-disabled'>Placed on {dayjs(createdOn).format('h:mm A, Do MMM YYYY')}</ThemedText>  
                        </ThemedView>
                    </ThemedView>
                    <ThemedView
                        position="absolute"
                        left={15}
                        top={32}
                        width={2}
                        height={60}
                        backgroundColor="border-primary"
                        zIndex={-1}
                        borderRadius="full"
                    />
                    <ThemedView flexDirection='row' > 
                        <Stepper color={colors['icon-action-primary']} color1={colors['bg-surface-primary']} color3={colors['bg-fill-emphasis-primary-1']}/>
                        <ThemedView  ml='sm'>
                            <ThemedText variant='b3s' color='text-primary'>We’re processing your request</ThemedText>
                            <ThemedText variant='b4r' color='text-secondary'>Request to be completed by {dayjs(expectedRenewalCompletionDate).format('Do MMM, YYYY')}</ThemedText>  
                        </ThemedView>
                    </ThemedView>
            </ThemedView>
            </ThemedView>
           
        </ThemedView>
        <ThemedView p="lg" backgroundColor="bg-fill-primary" borderTopColor="border-primary" borderTopWidth={1}>
            <Button label="Done" type="SOLID" overRideStyle={{marginTop:8}} handlePress={()=>{navigation.navigate(ROUTE.HOME)}}/>
        </ThemedView>
        </>
    )
}

export default RenewalStatus